import React from "react";
import "./FieldValueVerticalRxCell.scss";

function FieldValueVerticalRxCell(props) {
    return (
        <div {...props} render="">
            <p className="field-value-cell-header">{props.title}</p>
            {props.render &&
                props.render()
            }
            {!props.render &&
                <>
                    <span className="field-value-cell-value">{props.value || "-"}
                        {props.currency &&  (
                            <span> {props.currency}</span>
                        )}
                    </span>

                    {props.hint && (
                        <div className="field-value-cell-hint">{props.hint}</div>
                    )}
                </>
            }
        </div>
    );
}

export default FieldValueVerticalRxCell;
